import React from "react";
import classnames from "classnames";
import { Link, NavLink } from "react-router-dom";
import { getModifiersWithBoolValue } from "../utilities/modifier-generators";
import { withBem } from "../hocs";

const Menu = ({ inverted, cn, className, ...rest }) => (
  <ul
    {...rest}
    className={classnames(
      cn(String(), getModifiersWithBoolValue({ inverted })),
      className
    )}
  >
    {/* <li className={cn("item")}>
      <NavLink activeClassName="selected" exact to={`/`}>
        Home
      </NavLink>
    </li> */}
    <li className={cn("item")}>
      <NavLink activeClassName="selected" exact to={`/our-work`}>
        Our work
      </NavLink>
    </li>
    <li className={cn("item")}>
      <NavLink activeClassName="selected" exact to={`/our-projects`}>
        Our projects
      </NavLink>
    </li>
    <li className={cn("item")}>
      <NavLink activeClassName="selected" exact to={`/team`}>
        Our team
      </NavLink>
    </li>
    <li className={cn("item")}>
      <NavLink activeClassName="selected" exact to={`/contact-us`}>
        Contact
      </NavLink>
    </li>
  </ul>
);

export default withBem("menu")(Menu);
